var _line, _circle, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofenceActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 61,
    viewBox: "0 0 246 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.7812,
    y1: 30.25,
    x2: 243.781,
    y2: 30.25,
    stroke: "#9C4900",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2812,
    cy: 30.75,
    r: 30,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_813_743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2812,
    y: 10.75,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_813_743)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2812 14.75C28.3227 14.75 26.4444 15.528 25.0595 16.9129C23.6747 18.2978 22.8966 20.1761 22.8966 22.1346C22.8966 26.2134 29.32 36.3414 29.32 41.8269H31.2425C31.2425 36.3598 37.6659 25.8811 37.6659 22.1346C37.6659 20.1761 36.8878 18.2978 35.503 16.9129C34.1181 15.528 32.2398 14.75 30.2812 14.75ZM30.2812 18.4423C31.2605 18.4423 32.1997 18.8313 32.8921 19.5238C33.5845 20.2162 33.9736 21.1554 33.9736 22.1346C33.9736 23.1139 33.5845 24.053 32.8921 24.7455C32.1997 25.4379 31.2605 25.8269 30.2812 25.8269C29.302 25.8269 28.3628 25.4379 27.6704 24.7455C26.978 24.053 26.5889 23.1139 26.5889 22.1346C26.5889 21.1554 26.978 20.2162 27.6704 19.5238C28.3628 18.8313 29.302 18.4423 30.2812 18.4423ZM22.7046 36.0189C22.6783 36.0311 22.6525 36.0443 22.6271 36.0583C20.3563 36.4571 18.4314 37.0035 16.9742 37.7506C16.2443 38.1235 15.6154 38.5654 15.128 39.0958C14.6394 39.6275 14.2812 40.318 14.2812 41.0958C14.2812 42.2626 15.0542 43.1746 15.9736 43.8269C16.8929 44.4792 18.0536 44.9777 19.4739 45.4035C22.3108 46.2552 26.1028 46.75 30.2812 46.75C34.4597 46.75 38.2517 46.2552 41.0886 45.4035C42.5077 44.9777 43.6696 44.4805 44.5889 43.8269C45.5083 43.1746 46.2812 42.2626 46.2812 41.0958C46.2812 40.3155 45.9243 39.5894 45.4345 39.0577C44.9446 38.526 44.3219 38.1235 43.5883 37.7494C42.1237 37.0023 40.1803 36.4558 37.896 36.0571C37.7354 36.026 37.5702 36.0272 37.4101 36.0606C37.2499 36.0941 37.0981 36.1592 36.9634 36.252C36.8287 36.3448 36.7138 36.4636 36.6256 36.6014C36.5373 36.7391 36.4774 36.8931 36.4493 37.0542C36.4213 37.2154 36.4256 37.3806 36.4621 37.54C36.4986 37.6995 36.5666 37.8501 36.662 37.983C36.7574 38.1159 36.8783 38.2285 37.0177 38.3141C37.1571 38.3997 37.3122 38.4567 37.4739 38.4817C39.5945 38.8509 41.3569 39.374 42.4733 39.9426C43.032 40.2257 43.4246 40.5297 43.6277 40.75C43.8308 40.9703 43.8197 41.0577 43.8197 41.0958C43.8197 41.1537 43.7409 41.4195 43.1662 41.8269C42.5914 42.2343 41.6117 42.6811 40.3576 43.0577C37.8505 43.8097 34.2591 44.2885 30.2812 44.2885C26.3034 44.2885 22.712 43.8097 20.2037 43.0577C18.9508 42.6811 17.9711 42.2343 17.3976 41.8269C16.8216 41.4195 16.7428 41.1537 16.7428 41.0958C16.7428 41.0589 16.7342 40.9691 16.9348 40.75C17.1366 40.5309 17.5342 40.2257 18.0893 39.9426C19.1969 39.3752 20.9422 38.8522 23.0505 38.4805C23.2145 38.4606 23.3729 38.4082 23.5164 38.3263C23.6599 38.2445 23.7857 38.1349 23.8863 38.0039C23.987 37.8729 24.0605 37.7231 24.1027 37.5634C24.1448 37.4036 24.1546 37.2371 24.1317 37.0735C24.1087 36.9099 24.0533 36.7525 23.9688 36.6106C23.8843 36.4686 23.7723 36.3449 23.6395 36.2467C23.5066 36.1485 23.3555 36.0778 23.195 36.0387C23.0345 35.9996 22.8678 35.9929 22.7046 36.0189Z",
    fill: "#F6EFE9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.2812 14.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceActive);
export default __webpack_public_path__ + "static/media/geofence_active.3bd73107539896d6fe4f9cfc97720048.svg";
export { ForwardRef as ReactComponent };